import { MONITORAMENTO_ROUTE, PRESTACAO_CONTA_ROUTE } from '../constants/apiRoutes';
import { MESSAGES } from '../constants/messages';
import api from './api';

export default {
	exportAnalisePDF(id) {
		return api.get(
			MONITORAMENTO_ROUTE.EXPORT_PDF.replace('{id}', id),
			{ responseType: 'arraybuffer', errorMessage: MESSAGES.SEM_INFORMACOES_PDF },
		);
	},
	exportPrestacaoContasPDF(id) {
		return api.get(
			PRESTACAO_CONTA_ROUTE.EXPORT_PDF.replace('{id}', id),
			{ responseType: 'arraybuffer', errorMessage: MESSAGES.SEM_INFORMACOES_PDF_PRESTACAO_CONTAS },
		);
	},
};
